// eslint-disable-next-line import/prefer-default-export
export const STATIC_DONATIONS = [5, 10];
